import { render } from "./shebei-lesson.vue?vue&type=template&id=07c8ff26&scoped=true"
import script from "./shebei-lesson.vue?vue&type=script&lang=js"
export * from "./shebei-lesson.vue?vue&type=script&lang=js"

import "./shebei-lesson.vue?vue&type=style&index=0&id=07c8ff26&scoped=true&lang=less"

import exportComponent from "G:\\PRO\\shview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07c8ff26"]])

export default __exports__